import React from "react";
import {getImage} from "../../contentful/data-provider";
import {renderRichText} from "gatsby-source-contentful/rich-text";

const GreyBoxesSection = (props) => {
    const content = props.content;
    return (
        <section className="grey-boxes-section" key={content.id}>
            <div className="container">
                <div className="row grey-boxes-section--header section--header">
                    <div className="col-lg-12">
                        <h2>{content.title}</h2>
                    </div>
                </div>
                <div className="row grey-boxes-section--container">
                    { content.elements.map((element, index) => {
                        return (
                            <div className="col-lg-6" key={index}>
                                <div className="box">
                                    <div className="decorate-container">
                                        <div className="decorate">
                                            <span className="decorate__item"/>
                                            <span className="decorate__item"/>
                                        </div>
                                    </div>
                                    <img src={getImage(element.image).url} alt={getImage(element.image).title}/>
                                    <h5>{element.title}</h5>

                                    {element.body && renderRichText(element.body)}

                                    <ul className="downloads">
                                        { element.files && element.files.map((file, index) => {
                                            return (
                                                <li>
                                                    <a href={getImage(file).url} target="_blank" rel={'noreferrer'} key={index}>
                                                        <div className="download">
                                                            {file.title}
                                                        </div>
                                                    </a>
                                                </li>
                                            );
                                        }) }
                                    </ul>
                                </div>
                            </div>
                        );
                    }) }
                </div>
            </div>
        </section>
    )
}

export default GreyBoxesSection;
